const DEFAULT_OPEN_ORDERS_COLUMNS = [
  {
    id: "requested_date",
    label: "Requested Date",
    sortable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "ticket_number",
    label: "Ticket Number",
    sortable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "link",
    label: "Link to Part",
    sortable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "description",
    label: "Part Description",
    editable: true,
    type: "string",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "quantity",
    label: "Quantity",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "customer",
    label: "Customer",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "po_number",
    label: "PO Number",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "vendor_part_number",
    label: "Vendor Part #",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "warranty_type",
    label: "Warranty Type",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "status",
    label: "Current Status",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "ordered_date",
    label: "Ordered Date",
    editable: true,
    type: "date",
    show: true,
    resizable: true,
  },
  {
    id: "vendor",
    label: "Vendor",
    editable: true,
    dropdownOptions: ["Vendor1", "Vendor2"],
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "price",
    label: "Price",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "shipping_price",
    label: "Shipping Price",
    editable: true,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "total_price",
    label: "Total Price",
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "payment_method",
    label: "Payment Method",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "eta",
    label: "ETA",
    editable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "tracking_number",
    label: "Tracking",
    editable: true,
    type: "string",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "received_date",
    label: "Received Date",
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "notes",
    label: "Notes",
    editable: true,
    type: "string",
    width: "300",
    show: true,
    resizable: true,
  },
];

export default DEFAULT_OPEN_ORDERS_COLUMNS;
